import { render } from "./SkillPathCard.vue?vue&type=template&id=2dfc8f68"
import script from "./SkillPathCard.vue?vue&type=script&lang=js"
export * from "./SkillPathCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__